<mat-dialog-content class="container__dialog-database-use-authorization">
  <h2 class="h5_600" mat-dialog-title>{{'terms-conditions.use-authorization.title' | translate}}</h2>

  <p>{{'terms-conditions.use-authorization.description' | translate }}
    <strong>{{'terms-conditions.use-authorization.description2' | translate: { buildingName: data.building.name } }}
    </strong>
  </p>

  <p>{{'terms-conditions.use-authorization.sub-description' | translate}}</p>

  <div class="container__dialog-database-use-authorization__disclamer">
    <mat-icon class="icon__disclamer">info</mat-icon>
    <p>{{'terms-conditions.use-authorization.disclamer' | translate}}</p>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="center" class="custom__class-dialog-database-use-authorization__actions">
  <common-buttons-filled class="custom__button-filled"
    [label]="'terms-conditions.use-authorization.button.verify' | translate" [disabled]="isLoading"
    [iconPosition]="false" (output)="onEventVerify($event)"></common-buttons-filled>
</mat-dialog-actions>